import Image                 from "gatsby-image";
import React                 from "react";
import {PrototypPerfumImage} from "src/shared/Hooks/CasesNew/PrototypPerfum/PrototypPerfumImage";
import Opengraph             from "../../../../assets/images/cases/prototyp-perfum/og.png"

export const PrototypPerfumData = () => {
  const images = PrototypPerfumImage();
  return {
    color:       "#281B22",
    title:       "Perfumeria online",
    seo:
                 "E-commerce, który pachnie sukcesem.",
    slug:        "perfumeria-online",
    opengraph:   Opengraph,
    hero:        {
      title:      "E-commerce, który pachnie sukcesem.",
      color:      "#281B22",
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"cover"}
                      fluid={images.hero.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.detail.childImageSharp.fluid}
                    />
                  ),
    },
    what_we_did: {
      title:        "Autorska propozycja sklepu z perfumami",
      technologies: [
        "UX Workshops",
        "Aplikacja mobilna",
        "Identyfikacja wizualna",
        "CMS",
      ],
      text:
                    "W każdej branży podstawą jest budowanie pozytywnych relacji z każdym odbiorcą. Jak można to zrobić w branży perfumeryjnej? Na przykład za pomocą przejrzystej i zachęcającej do zakupów platformy e-commerce. Opracowaliśmy projekt sklepu online, który jest nowoczesny, funkcjonalny, a do tego wyróżnia się subtelną, ale zapadającą w pamięć szatą graficzną. Sprawdź naszą propozycję sklepu z perfumami. ",
      list:         [
        "Przygotowaliśmy propozycję identyfikacji wizualnej",
        "Opracowaliśmy widok sklepu internetowego",
        "Zaprojektowaliśmy nowoczesną aplikację mobilną",
      ],
    },
    logo:        {},
    headers:     {
      first: "E-commerce z kultowymi zapachami",
    },
    list:        {
      background: (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_bg.childImageSharp.fluid}
                    />
                  ),
      detail:     (
                    <Image
                      alt=""
                      objectPosition={"center"}
                      objectFit={"contain"}
                      fluid={images.list_detail.childImageSharp.fluid}
                    />
                  ),
    },
    full_images: {
      first:   {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_1.childImageSharp.fluid}
                 />
               ),
      },
      second:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_2.childImageSharp.fluid}
                 />
               ),
      },
      third:   {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_3.childImageSharp.fluid}
                 />
               ),
      },
      fourth:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_4.childImageSharp.fluid}
                 />
               ),
      },
      fifth:   {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_5.childImageSharp.fluid}
                 />
               ),
      },
      sixth:   {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_6.childImageSharp.fluid}
                 />
               ),
      },
      seventh: {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_7.childImageSharp.fluid}
                 />
               ),
      },
      eighth:  {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_8.childImageSharp.fluid}
                 />
               ),
      },
      ninth:   {
        image: (
                 <Image
                   alt=""
                   objectPosition={"center"}
                   objectFit={"contain"}
                   fluid={images.full_9.childImageSharp.fluid}
                 />
               ),
      },
    },

    text_boxes:     {
      first:   {
        title: "Na początek tablice inspiracji",
        text:  "Aby zaprojektować atrakcyjny dla klienta sklep z perfumami, zaczęliśmy od stworzenia moodboardów. Ułatwiły nam one pracę, a po wspólnej burzy mózgów wiedzieliśmy już, w którym kierunku chcemy zmierzać.",
      },
      second:  {
        title: "Delikatny, a wyrazisty przekaz",
        text:
               "Kolejnym krokiem było opracowanie identyfikacji wizualnej, którą wykorzystaliśmy w całym koncepcie. Postawiliśmy na stonowaną kolorystykę w odcieniach brązu, beżu i pomarańczu. W projekcie użyliśmy autorskich grafik. Zdecydowaliśmy się na użycie szeryfowej czcionki, przez co treść jest czytelna, a do tego nadaje elegancji całej witrynie.",
      },
      third:   {
        title: "Estetyczny i ciekawy design ",
        text:
               "Stworzyliśmy funkcjonalny projekt sklepu internetowego, który zawiera wszystkie elementy wpływające na podjęcie decyzji o zakupie. Układ strony jest intuicyjny i przejrzysty, co sprzyja ekspozycji sprzedawanych produktów.",
      },
      fourth:  {
        title: "Wymarzone perfumy na wyciągnięcie ręki",
        text:
               "Prezentacja produktów jest czytelna, a oferowane perfumy można filtrować pod kątem marki, ceny czy pojemności. Dzięki temu użytkownik serwisu może szybko i łatwo znaleźć pasujące do swoich oczekiwań zapachy.",
      },
      fifth:   {
        title: "Dobra prezentacja produktu kluczem do sukcesu",
        text:
               "Dzięki właściwej prezentacji produktów można pozyskać większą liczbę klientów i stale zwiększać sprzedaż. Dlatego postawiliśmy na szczegółowe przedstawienie perfum - wraz z opisem i zdjęciami. Spodobał Ci się dany zapach? Możesz dodać go do ulubionych! ",
      },
      sixth:   {
        title: "Zakupy w każdym miejscu i o każdej porze",
        text:
               "Według najnowszych danych coraz więcej Polaków robi zakupy przy użyciu swojego smartfona. Z tego powodu oczywistością było dostosowanie projektu do urządzeń mobilnych. Funkcjonalności, które zastosowaliśmy, pozwalają na szybkie zakupy za pomocą kilku kliknięć! ",
      },
      seventh: {
        title: "Skuteczne działania sprzedażowe",
        text:
               "W naszym projekcie uwzględniliśmy również rozwiązania, które będę wspierać pozycjonowanie się sklepu w wyszukiwarce. Dzięki połączeniu witryny z blogiem możliwe jest zdobywanie nowych klientów. A dzięki wykorzystanemu systemowi CMS istnieje również możliwość uzupełnienia strony o nowe wpisy w prosty i intuicyjny sposób.",
      },
    },
    content_images: {
      first:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_1.childImageSharp.fluid}
                />
              ),
      second: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_2.childImageSharp.fluid}
                />
              ),
      third:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_3.childImageSharp.fluid}
                />
              ),
      fourth: (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_4.childImageSharp.fluid}
                />
              ),
      fifth:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_5.childImageSharp.fluid}
                />
              ),
      sixth:  (
                <Image
                  alt=""
                  objectPosition={"center"}
                  objectFit={"contain"}
                  fluid={images.img_6.childImageSharp.fluid}
                />
              ),
    },
  };
};
